import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/footer.scss";

const footerGroups = [
  {
    title: "CUSTOMER CARE",
    links: [
      ["Contact", "/contact"],
      ["Shipping", "/shipping"],
      ["Returns", "/returns"],
      ["Payment options", "/shipping#payment-options"],
      ["FAQs", "/faqs"],
    ],
  },
  {
    title: "COMPANY",
    links: [
      ["About the brand", "/about"],
      ["Sustainability", "/about#values"],
    ],
  },
  {
    title: "LEGAL",
    links: [
      ["Privacy policy", "/privacy"],
      ["Terms of use", "/terms"],
      ["Cookie policy", "/cookies"],
    ],
  },
];

function Footer() {
  const [openGroup, setOpenGroup] = useState(null);
  const [isDesktop, setIsDesktop] = useState(
    () =>
      typeof window !== "undefined" &&
      typeof window.matchMedia === "function" &&
      window.matchMedia("(min-width: 1025px)").matches,
  );
  const location = useLocation();
  const isMinimal = ["/checkout", "/paysuccess"].includes(location.pathname);

  useEffect(() => {
    if (typeof window.matchMedia !== "function") return undefined;
    const media = window.matchMedia("(min-width: 1025px)");
    const handleChange = (event) => setIsDesktop(event.matches);
    media.addEventListener?.("change", handleChange);
    return () => media.removeEventListener?.("change", handleChange);
  }, []);

  if (isMinimal) {
    return (
      <footer className="site-footer site-footer--minimal">
        <span>Ship to United States · English</span>
        <nav aria-label="Checkout legal links">
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Terms</Link>
          <Link to="/contact">Help</Link>
        </nav>
        <span>
          © {new Date().getFullYear()} {siteConfig.brandName}
        </span>
      </footer>
    );
  }

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-grid">
        <section className="footer-contact" aria-labelledby="footer-contact-title">
          <h2 id="footer-contact-title">CONTACT</h2>
          <a href={`mailto:${siteConfig.contact.email}`}>
            {siteConfig.contact.email}
          </a>
          <strong>{siteConfig.companyName}</strong>
          <address>{siteConfig.contact.address}</address>
        </section>

        <div className="footer-links">
          {footerGroups.map((group) => (
            <section
              key={group.title}
              className={
                isDesktop || openGroup === group.title ? "is-open" : ""
              }
            >
              <button
                className="footer-group-toggle"
                type="button"
                onClick={() =>
                  !isDesktop &&
                  setOpenGroup((current) =>
                    current === group.title ? null : group.title,
                  )
                }
                aria-expanded={isDesktop || openGroup === group.title}
              >
                <h2>{group.title}</h2>
                <span aria-hidden="true">+</span>
              </button>
              <div className="footer-group-links">
                {group.links.map(([label, to]) => (
                  <Link key={label} to={to}>
                    {label}
                  </Link>
                ))}
              </div>
            </section>
          ))}
        </div>
      </div>
      <div className="footer-bottom">
        <a href={siteConfig.website}>{siteConfig.website.replace("https://", "")}</a>
        <span>
          © {new Date().getFullYear()} {siteConfig.brandName}
        </span>
      </div>
    </footer>
  );
}

export default Footer;
